import { MediaTypes } from '@setplex/tria-api'
import { combine, createEvent, createStore, restore, sample } from 'effector'
import { register } from '~/core/repository'
import { MediaTypesExtended, model as paymentModel } from '~/features/payment'
import * as pinLockFeature from '~/features/pin-lock'
import { F, T } from '~/shared/helpers'
import { paymentTvModelWidget } from '../../model'
import { $externalPayment } from './l10n'

// Intermediate state
const $externalPaymentPopupIsOpenedStage = createStore<boolean>(false)

// Means popup blocked from showing
export const setBlocked = createEvent<boolean>()
export const $isBlocked = restore(setBlocked, false)

// Popup state
export const $isOpened = combine(
  $externalPaymentPopupIsOpenedStage,
  $isBlocked,
  (state, isBlocked) => (isBlocked ? false : state)
)

// open popup
sample({
  clock: paymentModel.openExternalPaymentPopup,
  filter: paymentModel.$externalPaymentEnabled,
  fn: T,
  target: $externalPaymentPopupIsOpenedStage,
})

// close popup
sample({
  clock: paymentModel.closeExternalPaymentPopup,
  fn: F,
  target: $externalPaymentPopupIsOpenedStage,
})

// inform generic model
sample({
  clock: $externalPaymentPopupIsOpenedStage,
  target: paymentModel.$isAnyPaymentPopupOpened,
})

export const closePopup = createEvent()

export const autoClosePopup = createEvent()
export const userClosePopup = createEvent()

sample({
  clock: [autoClosePopup, userClosePopup],
  target: closePopup,
})

sample({
  clock: paymentModel.proceedFx.done,
  target: autoClosePopup,
})

sample({
  clock: closePopup,
  target: paymentModel.closeExternalPaymentPopup,
})

// reset unlock id only for tv channels
sample({
  clock: userClosePopup,
  source: paymentModel.$selectedContent,
  filter: (selectedContent) =>
    selectedContent?.mediaType === MediaTypes.TV_CHANNEL ||
    selectedContent?.mediaType === MediaTypesExtended.TV_CHANNEL_IN_BUNDLE ||
    selectedContent?.mediaType === MediaTypesExtended.TV_CHANNEL_CATCHUP,
  target: [
    pinLockFeature.resetUnlockId,
    paymentTvModelWidget.resetSelectedChannel,
  ],
})

const $externalPaymentButtonTitle = combine(
  $externalPayment,
  ({ proceedToPurchase }) => proceedToPurchase
)

/*
 * Register stores and events for skin
 */

register($externalPayment, '$payment/external')
register(
  $externalPaymentButtonTitle,
  '$payment/external/externalPaymentButtonTitle'
)
register(paymentModel.giveItATry, 'payment/external/try')
register(userClosePopup, 'payment/external/closePopup')
register(paymentModel.proceed, 'payment/external/proceed')
register($isOpened, '$payment/external/isPopupOpened')
